import React from 'react';
import {Bids, Header, } from '../../components'
import 'react-html5video/dist/styles.css';
import { DefaultPlayer as Video } from 'react-html5video';
import videolink from '../../assets/laughing_ghost_horror_sounds.mp3'
import MettingHexa from '../../assets/MettingHexa.jpg'


const HexaEyes = () => {

  return <div>
    <div>
    <Video autoPlay loop controls={[]} style={{width:'1700px', zindex:-1, visibility:'hidden', position:'absolute'}}>
            <source src={videolink} type='audio/mp3'/>
          </Video>
    <img src={MettingHexa} alt="" width={'100%'} style={{zindex:10}}/>
        
   </div>
  </div>;
};

export default HexaEyes;
